import axios from 'axios'
import store from "@/store";
async function getPhotosRoute(idRoute) {
    try {
      let response = await axios.get(
        process.env.VUE_APP_BASE_ONETRACK_EXT + "/route/photo/" + idRoute
      );
      return response.data;
    } catch (error) {
      console.log(error);
    }
  }
  async function getStores() {
    try {
      const token = store.getters["module/token"];
      let response = await axios.get(
        process.env.VUE_APP_ENDPOINT_STORE + "/stores?limit=1000&page=1",
        {
          headers: {
              "Content-type": "application/json",
              "Authorization": "Bearer "+ token
            }
        }
      );
      let filterData=response.data.filter((c) => c.company ==='HPSA');
      const data = filterData.map((row) => {
        return {
          value: row.code,
          text: row.code + "-" + row.name,
        };
      });
      return data;
    } catch (error) {
      console.error(error);
    }
  }
  async function generateTokenApiGee(){
    try {
     
     let response = await axios.post(
       "https://migracion.api.promart.pe/oauth/client_credential/accesstoken?grant_type=client_credentials",
      {
       data:""
      },
       {
         headers: {
           "Content-type": "application/json",
           "Authorization": "Basic cjRSRXBTWlBia2QzOTN1RzM4R0c5UzZLTnNZR0c1TWFXRk9zTFlaR0FqRTh2NWFqOmtVa0cwNTFiMkhTa1FWZmc0SjBHOWkwOU1CQnBjS2ZNc29BNlpBWVowMXFKY1ZjakFYSkd1TlVRdXBtdFVTV0c="
         },
       }
     );
     store.commit("module/setToken", response.data.access_token);
   } catch (error) {
     console.log(error);
   } 
 }
  async function createLogs(url,username,method,view) {
    try {
      console.log(url,username,method,view)
      let response = await axios.post(
        process.env.VUE_APP_LOGS_EXT + "/transaction-logs",
        {
          observations: url,
          ok: true,
          process:username,
          transactionInfo:method,
          data:view
        }, // the data to post
        {
          headers: {
            "Content-type": "application/json",
          },
        }
      ); 
      return response.data;
    } catch (error) {
      console.log(error);
    }
  }
  export { getPhotosRoute,createLogs,getStores,generateTokenApiGee };